import ProfilePage from "@/pages/sidebar/profile";
import ProfileEditPage from "@/pages/sidebar/profile/edit";
import ProfileEditGeneralPage from "@/pages/sidebar/profile/edit-personal";
import ProfileEditPaymentPage from "@/pages/sidebar/profile/edit-payment";

export const profileRoute = {
  path: "/profile",
  children: [
    { path: "/profile", element: <ProfilePage /> },
    // { path: "/profile/edit", element: <ProfileEditPage /> },
    { path: "/profile/edit/general", element: <ProfileEditGeneralPage /> },
    { path: "/profile/edit/payment", element: <ProfileEditPaymentPage /> },
  ],
};
